var map = {
	"./ground_base0.png": 6517,
	"./ground_base1.png": 3628,
	"./ground_base12.png": 5716,
	"./ground_base123.png": 5989,
	"./ground_base13.png": 5661,
	"./ground_base2.png": 8455,
	"./ground_base23.png": 6908,
	"./ground_base3.png": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5031;